module.exports = __webpack_public_path__ + "static/media/column.5d418d83.png";